import { getDefaultExportFromCjs } from '../../_virtual/_commonjsHelpers.js';
import { __module as propTypes } from '../../_virtual/index3.js';
import { __require as requireReactIs } from '../react-is/index.js';
import { __require as requireFactoryWithTypeCheckers } from './factoryWithTypeCheckers.js';
import { __require as requireFactoryWithThrowingShims } from './factoryWithThrowingShims.js';

if(process.env.NODE_ENV!=="production"){var ReactIs=requireReactIs();var throwOnDirectAccess=true;propTypes.exports=requireFactoryWithTypeCheckers()(ReactIs.isElement,throwOnDirectAccess);}else {propTypes.exports=requireFactoryWithThrowingShims()();}var propTypesExports=propTypes.exports;var PropTypes = getDefaultExportFromCjs(propTypesExports);

export { PropTypes as default };
//# sourceMappingURL=index.js.map
